module.exports = __webpack_public_path__ + "static/media/icon-toggle-off.da116148.svg";